import type { SVGProps } from 'react'

/** Icono paquete / pedidos — diseño cuenta (no reutiliza el de sidebar). */
export function AccountOrdersIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg
            width="51"
            height="51"
            viewBox="0 0 51 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...props}
        >
            <g clipPath="url(#clip-account-home-orders)">
                <path
                    d="M10.9697 16.428L25.1666 9.70941L39.426 16.6257V32.7104L26.3438 39.6721C25.6028 40.0426 24.7304 40.0418 23.9902 39.6698L10.9697 32.7104V17.9101"
                    fill="white"
                />
                <g opacity="0.5">
                    <path
                        d="M16.0464 13.9398L30.2377 20.7561V26.4866L34.7387 24.351V18.6533L20.6575 11.7401"
                        fill="#FB5151"
                    />
                </g>
                <path
                    d="M37.3507 17.416L26.0835 22.8065C25.5035 23.084 24.8289 23.0832 24.2497 22.8057L10.9697 16.428L25.1658 9.70941L39.426 16.6257V32.7104L26.343 39.6721C25.6028 40.0426 24.7304 40.0418 23.9902 39.6698L10.9697 32.7104V17.9101"
                    stroke="#686058"
                    strokeWidth="1.2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25.1846 22.909V37.6828"
                    stroke="#686058"
                    strokeWidth="1.2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip-account-home-orders">
                    <rect
                        width="30.24"
                        height="32.0188"
                        fill="white"
                        transform="translate(10.0801 8.82001)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

/** Mis favoritos — diseño cuenta */
export function AccountWishlistIcon(
    props: SVGProps<SVGSVGElement>
): JSX.Element {
    return (
        <svg
            width="33"
            height="31"
            viewBox="0 0 33 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...props}
        >
            <path
                d="M18.752 6.10838L17.4869 7.24452C12.6523 0.838618 5.82737 1.97476 4.17553 7.65547C2.3706 13.8519 9.48559 27.0585 13.1357 27.9287C16.7859 28.799 29.6944 18.7832 29.912 9.96804C30.1295 1.15287 21.4997 4.16647 18.752 6.10838Z"
                fill="#FF8773"
            />
            <path
                d="M31.4513 6.66438C30.3635 3.75554 26.7134 2.36155 23.6273 2.94976C21.1673 3.53571 18.9085 4.76804 17.0844 6.51934C16.7048 5.44657 16.119 4.45841 15.36 3.6105C12.3948 0.306822 6.73825 -0.547299 3.42651 2.40989C0.114781 5.36708 0.203416 10.2984 1.22675 14.4965C2.4757 19.3876 9.01859 29.7095 12.2739 29.7095C15.5292 29.7095 28.0026 19.6535 30.7261 13.167C31.5883 11.08 32.2249 8.75134 31.4513 6.66438Z"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

/** Gift cards — diseño proporcionado (sidebar usa otro ícono regalo). */
export function AccountGiftCardIcon(
    props: SVGProps<SVGSVGElement>
): JSX.Element {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...props}
        >
            <path
                opacity="0.5"
                d="M12.9865 26.9676C11.3545 26.1425 10.0084 24.8319 9.12745 23.2102C8.58967 22.0886 8.3207 20.8536 8.34254 19.6062C8.36438 18.3588 8.6764 17.1343 9.25309 16.0328C9.62458 15.3276 10.1647 14.7285 10.8237 14.2909C11.4025 14 12.0334 13.8314 12.6782 13.7953C13.323 13.7593 13.9683 13.8565 14.5751 14.0812C15.8922 14.3925 17.1077 15.0449 18.1032 15.975C19.0987 16.9051 19.8404 18.0813 20.256 19.389C21.0684 18.3766 22.1231 17.5933 23.3191 17.1142C24.515 16.6351 25.812 16.4763 27.0857 16.653C28.0916 16.8094 29.0289 17.2666 29.7781 17.9663C30.6163 18.782 31.1196 19.8897 31.1871 21.067C31.2082 21.6852 31.1232 22.3025 30.9358 22.891C30.0384 25.7547 27.4896 26.9038 25.3267 27.7428C22.9236 28.6783 20.3206 28.955 17.779 28.5454C16.1085 28.2846 14.4902 27.7519 12.9865 26.9676V26.9676Z"
                fill="#EEE0B9"
            />
            <path
                d="M19.6277 11.6279C19.6277 11.4729 5.79781 11.7647 5.65421 11.8833C5.51062 12.0018 6.14782 27.6607 6.30936 31.0351C6.30936 31.181 33.6551 31.1628 33.9513 30.8801C34.05 30.7889 34.2385 11.9745 34.1038 11.8377C33.9823 11.7386 33.8285 11.6898 33.6731 11.7009C31.3038 11.5732 23.2984 11.3725 20.9201 11.3725C21.7916 11.3424 22.6425 11.0955 23.3982 10.6535C24.154 10.2115 24.7915 9.58783 25.2548 8.8372C25.5176 8.38762 25.6541 7.87352 25.6497 7.35066C25.6497 6.12859 24.5817 5.65435 23.5138 5.60875C22.652 5.57923 21.8001 5.80265 21.06 6.25228C20.3199 6.70191 19.7229 7.35871 19.3405 8.14409C19.1335 8.51458 19.0665 8.94907 19.1521 9.36616C19.2032 9.56966 19.3299 9.74512 19.5056 9.85566C19.6813 9.9662 19.8924 10.0032 20.0944 9.95896C21.6381 9.41176 19.7444 6.80346 19.1252 6.22891C18.3777 5.53932 17.4841 5.03379 16.5135 4.75148C15.9005 4.57381 15.2508 4.57381 14.6378 4.75148C14.3324 4.83997 14.0542 5.00618 13.8297 5.23439C13.6051 5.4626 13.4415 5.74526 13.3545 6.05563C13.3077 6.41812 13.345 6.7867 13.4634 7.13191C13.5819 7.47712 13.7781 7.7894 14.0365 8.04377C14.4709 8.53793 14.9977 8.93921 15.5864 9.22419C16.175 9.50918 16.8136 9.67215 17.4648 9.7036C15.4994 10.6703 11.9724 10.0319 11.1826 6.96762"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.53125 23.9398H17.9674"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.87207 26.922H19.9147C19.9147 26.922 31.1779 26.3475 27.9919 14.373"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M30.7741 16.6803C30.0575 16.2042 29.2159 15.9594 28.3599 15.9781C27.4624 15.9781 25.847 16.425 25.9457 17.4008C26.0445 18.3766 27.2201 18.4952 28.0907 18.477C28.8176 18.477 30.4779 18.477 30.7831 19.6352C30.9985 20.5016 30.2356 21.1856 29.3202 21.5413C28.7482 21.702 28.1473 21.7255 27.5648 21.61C26.9823 21.4944 26.4342 21.243 25.9637 20.8755"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export function AccountSavedCardsIcon(
    props: SVGProps<SVGSVGElement>
): JSX.Element {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...props}
        >
            <path
                opacity="0.5"
                d="M10.1045 10.9986C8.8569 11.6268 7.81307 12.6059 7.09713 13.8194C6.38119 15.0329 6.02327 16.4298 6.06591 17.844C6.08604 19.255 6.5079 20.6299 7.2805 21.8024C8.05309 22.975 9.14336 23.8951 10.4195 24.4514C11.4324 24.7919 12.4948 24.9557 13.5615 24.9357C18.413 24.9975 23.1843 23.6752 27.3331 21.119C27.9515 20.7775 28.4805 20.2907 28.8759 19.699C29.3124 18.8062 29.5128 17.8134 29.4574 16.818C29.4574 15.5951 29.5301 14.3557 29.5624 13.1327C29.6225 12.577 29.5534 12.0147 29.3605 11.4911C28.8759 10.4815 27.6562 10.342 26.6304 10.342L14.8135 10.3009C13.2166 10.1848 11.6134 10.4055 10.1045 10.9494"
                fill="#EEE0B9"
            />
            <path
                d="M5.5249 12.9603C5.5249 12.9603 20.1931 11.5404 30.6934 12.4186"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinejoin="round"
            />
            <path
                d="M11.7281 26.3967C8.99802 26.5034 8.92532 26.6101 6.18716 26.7086C5.65406 22.7524 4.9675 8.88921 5.13712 8.87279C13.5374 8.19153 30.6852 8.35569 30.8064 8.42136C30.9276 8.48702 30.8064 25.8796 30.7014 25.9699C30.5964 26.0602 15.9282 25.7893 14.3613 25.7483C13.7474 25.7483 13.2466 25.6744 12.9558 26.3393C12.8718 26.5037 12.8356 26.689 12.8513 26.8736C12.8671 27.0582 12.9341 27.2344 13.0447 27.3817C13.1669 27.5029 13.3197 27.5875 13.4862 27.6262C13.6527 27.6649 13.8265 27.6562 13.9885 27.6011C14.1504 27.5459 14.2943 27.4465 14.4042 27.3137C14.5142 27.1808 14.5859 27.0198 14.6117 26.8482C15.3801 24.4137 15.4166 21.8018 14.7167 19.3461C14.6827 19.2012 14.6025 19.0719 14.4885 18.9783C14.3745 18.8847 14.2332 18.8322 14.0866 18.829L9.49072 19.0178C9.4122 19.0198 9.33489 19.038 9.26347 19.0712C9.19204 19.1044 9.12798 19.152 9.07514 19.2111C9.02231 19.2701 8.98179 19.3394 8.95604 19.4148C8.93029 19.4903 8.91984 19.5702 8.92532 19.6498L9.20802 23.4993L13.812 23.2777"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.437 19.5267C16.6252 19.6062 16.7926 19.7289 16.9262 19.8853C17.0597 20.0417 17.1557 20.2275 17.2066 20.428C17.2575 20.6285 17.2619 20.8383 17.2194 21.0408C17.177 21.2433 17.0889 21.433 16.962 21.5951"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.8652 17.8358C16.8652 17.8358 20.5646 19.699 17.891 23.0643"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

/** Mis suscripciones — banner cuenta (no coincide con IconChevronRight 24×24). */
export function AccountSubscriptionsBannerIcon(
    props: SVGProps<SVGSVGElement>
): JSX.Element {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...props}
        >
            <rect width="36.0072" height="36.0072" fill="white" />
            <path
                d="M18.0159 9.97462C16.0858 9.8545 14.1796 10.4593 12.6597 11.674C11.4605 12.6968 10.5772 14.0495 10.1158 15.5697C9.65433 17.09 9.63439 18.7133 10.0583 20.2448C10.3484 21.0724 10.7163 21.8697 11.157 22.6256C11.3573 23.0412 11.5953 23.437 11.868 23.8077C14.3562 26.9274 20.0599 26.6482 22.8066 24.1115C23.6137 23.3263 24.2591 22.3859 24.7052 21.3449C26.2724 17.9707 25.8927 13.9563 22.7501 11.715C21.364 10.6951 19.7234 10.0919 18.0159 9.97462V9.97462Z"
                fill="#9DE0C1"
            />
            <path
                d="M17.9431 23.4712C19.3892 23.7257 22.5561 24.8504 22.6207 24.6287C22.6854 24.407 21.005 20.2612 21.1746 20.0231C21.3443 19.7851 25.109 17.2155 25.0847 17.002C25.0201 16.2632 20.5041 16.2221 20.286 15.8937C20.1728 15.7131 18.1612 11.3867 17.9997 11.2882C17.8381 11.1896 15.3498 15.5489 14.9863 15.7624C14.6227 15.9758 9.37959 16.8871 9.39575 17.1826C9.39575 17.7245 13.5967 19.7276 13.7502 20.056C13.9037 20.3844 12.4011 23.3398 12.3526 24.0869C12.3395 24.1513 12.3407 24.2179 12.3561 24.2818C12.3714 24.3457 12.4006 24.4053 12.4414 24.4563C12.5465 24.563 16.2466 23.545 16.4162 23.6353C16.5859 23.7257 16.6263 24.0787 16.5939 24.3332C16.4404 25.3922 16.3516 27.2804 16.1173 28.323C16.0898 28.4995 16.0149 28.6648 15.9007 28.8007C15.7865 28.9366 15.6376 29.0378 15.4704 29.093C15.3031 29.1482 15.1241 29.1554 14.9531 29.1137C14.7822 29.072 14.6259 28.983 14.5015 28.8566C14.3883 28.7076 14.319 28.5289 14.3018 28.3414C14.2847 28.1539 14.3203 27.9653 14.4046 27.7976C14.7035 27.1162 15.2125 27.1737 15.8507 27.1901C17.4665 27.1901 30.6026 27.4856 30.6995 27.4117C30.7965 27.3379 31.0065 9.5149 30.8045 9.39996C30.6026 9.28503 13.0878 9.1783 4.45961 9.85149C4.28995 9.85149 4.95241 24.1033 5.54217 28.167C8.35358 28.0603 10.3894 27.9536 13.1605 27.8386"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

/** Colaborador — banner cuenta (mismo estilo tarjeta/suscripciones, 36×36). */
export function AccountEmployeeIcon(
    props: SVGProps<SVGSVGElement>
): JSX.Element {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...props}
        >
            <rect width="36.0072" height="36.0072" fill="white" />
            <path
                opacity="0.5"
                d="M8.5 12.5C8.5 10.567 10.067 9 12 9H24C25.933 9 27.5 10.567 27.5 12.5V24.5C27.5 26.433 25.933 28 24 28H12C10.067 28 8.5 26.433 8.5 24.5V12.5Z"
                fill="#9DE0C1"
            />
            <rect
                x="8.5"
                y="9"
                width="19"
                height="19"
                rx="3.5"
                stroke="#686058"
                strokeWidth="1.2"
            />
            <circle
                cx="18"
                cy="15.5"
                r="3.2"
                stroke="#686058"
                strokeWidth="1.2"
            />
            <path
                d="M12.6 24.4C13.2 21.4 15.4 19.6 18 19.6C20.6 19.6 22.8 21.4 23.4 24.4"
                stroke="#686058"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

/** Flecha fila lista cuenta (8×12); distinta de components/icons/IconChevronRight (24×24, stroke). */
export function AccountRowChevronIcon(
    props: SVGProps<SVGSVGElement>
): JSX.Element {
    return (
        <svg
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...props}
        >
            <path
                d="M7.1087 5.892C7.1087 6.172 6.98478 6.41598 6.73681 6.62398C4.77149 8.29598 2.79239 9.93194 0.799515 11.5319C0.49645 11.7799 0.193339 11.7759 -0.109725 11.5199L-0.385255 11.268C-0.541379 11.132 -0.5459 10.9959 -0.39896 10.8599L5.04235 6.03599C5.08827 5.99599 5.1113 5.96799 5.1113 5.95199C5.12048 5.92799 5.125 5.908 5.125 5.892C5.125 5.86 5.125 5.83593 5.125 5.81993C5.11582 5.79593 5.08827 5.76398 5.04235 5.72398L-0.330099 0.839974C-0.477039 0.703974 -0.467828 0.567941 -0.30252 0.431941L-0.0270747 0.192C0.27599 -0.064 0.579101 -0.064 0.882165 0.192C2.84749 1.808 4.80365 3.46394 6.7506 5.15994C6.99857 5.36794 7.11788 5.612 7.1087 5.892Z"
                fill="#7F7373"
            />
        </svg>
    )
}
